import React from 'react';

import { Button } from '@shared/components/bootstrap';

import { useQA } from '@admin/hooks/use_qa';
import { client } from '@admin/libraries/apollo';
import { Order, OrderStateEnum, OrderTypeEnum, useOrderPickupCompleteMutation } from '@admin/schema';

export const OrderPickupCompleteButton: React.FC<{
  order: Pick<Order, 'type' | 'id' | 'state'>;
}> = ({ order }) => {
  const qa = useQA();
  const [execute, { loading }] = useOrderPickupCompleteMutation({
    client,
    variables: { orderID: order.id },
  });

  const completable = order.state === OrderStateEnum.Packed && order.type === OrderTypeEnum.Pickup;
  if (!qa || !completable) return null;

  const complete = async () => {
    await execute();
    location.reload();
  };

  return (
    <Button loading={loading} kind="warning" onClick={complete}>
      Auto-Complete Pickup
    </Button>
  );
};
